import { createRootRoute, Outlet } from '@tanstack/react-router';
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/context/auth-context';
import { ErrorBoundary } from '@/components/error-boundary';
import { initPerformanceMonitoring } from '@/lib/performance';
import '../styles/globals.css';

// Initialize performance monitoring
initPerformanceMonitoring();

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Outlet />
        <Toaster />
        {/* Disable devtools in mobile prototype as they intercept touches */}
        {/* {import.meta.env.DEV && <TanStackRouterDevtools position="top-right" />} */}
      </AuthProvider>
    </ErrorBoundary>
  );
}
